/** A sheet of Manual on the Platen page, with an optional title row. The container for a block of content. */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Card.module.css'

export function Card({
  title,
  count,
  action,
  flush,
  children,
}: {
  title?: string
  count?: number
  /** A button or link at the right of the title row. */
  action?: ReactNode
  /** No inner padding: a table or list runs to the edges. */
  flush?: boolean
  children: ReactNode
}) {
  return (
    <section className={cx(s.card, flush && s.flush)}>
      {(title || action) && (
        <header className={s.head}>
          {title && (
            <h2 className={s.title}>
              {title}
              {count !== undefined && <span className={s.n}>{count}</span>}
            </h2>
          )}
          {action}
        </header>
      )}
      {children}
    </section>
  )
}
